/* eslint-disable no-unused-vars */

import { saveAs } from 'file-saver';
import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { GetDocumentLink } from 'store/actions/complianceActions';
import { getFile } from 'store/actions/editorActions';
import { extractDocName } from '../../utils';

export default function NavBar({ title, currentVersion, handleClose }) {
    const [isLoading, setIsLoading] = useState(false);

    const dispatch = useDispatch();

    async function getDocumentLink() {
        try {
            setIsLoading(true);

            const authorizedUrlResponse = await dispatch(GetDocumentLink('userdoc', currentVersion?.id));
            if (!authorizedUrlResponse?.success) {
                throw new Error('Failed to get authorized document link');
            }

            const fileResponse = await dispatch(getFile(authorizedUrlResponse?.data));
            if (!fileResponse?.success) {
                throw new Error(fileResponse?.message);
            }

            saveAs(
                fileResponse?.blob,
                extractDocName((currentVersion?.filename || currentVersion?.document)?.replaceAll('_', ' '))
            );
        } catch (error) {
            toast.error(error?.message || 'Something went wrong!');
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            <div className="border-b border-[#F1F5F9] !px-6 !py-4 flex items-center justify-between">
                <div className="flex items-center !gap-6">
                    <img
                        src="/img/automated-scan/arrow-left-icon.svg"
                        alt="arrow-left-icon"
                        onClick={handleClose}
                        className="cursor-pointer object-contain"
                    />

                    <h3 className="text-[#002C72] capitalize font-bold text-lg">Acceptance history:: {title}</h3>
                </div>

                <div className="flex items-center !gap-1">
                    <div>
                        <button
                            onClick={(event) => {
                                event.stopPropagation();
                                getDocumentLink();
                            }}
                            className="transition-all hover:brightness-95 bg-white !rounded-lg !border !border-[#E2E8F0] !py-1 !px-1.5 flex items-center disabled:opacity-50 disabled:pointer-events-none"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <Loader2 className="!h-5 !w-5 animate-spin" />
                            ) : (
                                <img src="/img/frameworks/download.svg" alt="download" className="!w-5 !h-5" />
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
